import css from 'styled-jsx/css';
import colors from '../../../config/colors';
import font from "../../../config/fonts";

export const PromotionStyle = css`
	.filter-heading {
		font-family: ${font.bold} !important;
		font-size: 1.125rem;
		font-weight: 700;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		color: ${colors.Black40};
		margin-bottom: 1rem;
	}

	@media screen and (max-width: 576px) {
		ul {
			display: none;
		}
		.filter-heading {
			display: inline-block;
			font-family: ${font.medium} !important;
			font-size: 1rem;
			font-weight: 500;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			color: ${colors.Grey70};
			margin-bottom: 0;
		}
	}
	
`;
